import React from "react";
import MainLayOut from '../layout/MainLayOut';
import HeroSection from '../components/HeroSection';
import HomeBody from '../components/HomeBody';
import { Link } from 'react-router-dom';

const Home = () => {
    return (
        <>
            <div className="bg-brand-700 header_top">
                {/* <div className="max-w-7xl mx-auto p-2 text-center text-xs text-white">
                    <div>Free Shipping on all orders above ₹399 <Link className="text-brand-600 font-semibold" to={'/products'}>Shop Now</Link></div> */}
                    <div className="bg-brand-600">
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="flex items-center justify-center h-10 text-xs md:text-sm text-white text-center">
                            <span>Free Shipping on all orders above ₹999</span>
                            <span className="mx-2">|</span>
                            <Link to={'/products'} className="underline hover:no-underline">Shop Now</Link>
                        </div>
                        </div>
                    </div>
                {/* </div> */}
            </div>
            <MainLayOut>
                <HeroSection />
                <HomeBody />
            </MainLayOut>
        </>



    )
}

export default Home;